import { createStore } from "vuex";
import themeLayout from "./modules/themeLayout/actionCreator";

export default createStore({
  modules: {
    themeLayout,
  },
});
